import { I21RENDETAS_State } from '@batical/types/src'

const I21RENDETAS: I21RENDETAS_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  modelegenerateur: '',
  in_rendement30PCI: 300.0,
  in_rendement100PCI: 280.0,
  in_rendement30PCS: 270.0,
  in_rendement100PCS: 252.0,
  in_puissance30: 20.0,
  in_puissance100: 100.0,
  in_puissanceArret: 0.005,
  in_perteArret: 0.34,
  in_puissanceVeilleuse: 0.0,
  in_puissanceMin: 23.0,
  in_puissanceMax: 68.6,
  res_F1: 0.0,
  res_F2: 0.0,
  res_F3: 0.0,
  res_F4: 0.0,
  res_somme: 0.0,
  res_rendementSon: 0.0,
  res_rendement: 0.0,
  mode: 'none',
  calcul_code: 'I21RENDETAS'
}

export default I21RENDETAS
